import privateAlbumApi from '../api/privateAlbumApi';
import { IApiResponse } from '../interfaces/IApiResponse';
import albumModel from '../models/album';
import photoModel from '../models/photo';

interface Album {
  ImageCount: number;
  GalleryID: string;
  HasAccess: boolean;
}

interface Photo {
  GalleryID: string;
}

class PrivateAlbumService {
  async grantedAccess(galleryIds: string[] | number[], friendId: string | number, expiredTime: number): Promise<any[]> {
    const grantedAccessFunc: Promise<any>[] = [];
    galleryIds.forEach(galleryId => grantedAccessFunc.push(privateAlbumApi.grantedAccess(galleryId, friendId, expiredTime)));

    return Promise.all(grantedAccessFunc).then(res => {
      return res;
    });
  }

  removeGrantedAccess(
    galleryIds: string[] | number[],
    friendId: string | number
  ): Promise<{ data: {}; success: boolean; message: string }> {
    const removeGrantedAccessFunc: Promise<any>[] = [];
    galleryIds.forEach(galleryId => removeGrantedAccessFunc.push(privateAlbumApi.removeGrantedAccess(galleryId, friendId)));

    return Promise.all(removeGrantedAccessFunc).then(res => {
      const tempRes = { data: {}, success: true, message: '' };
      return tempRes;
    });
  }

  getAlbumInfos(friendId: string | number): Promise<IApiResponse<any>> {
    return privateAlbumApi.getUserGalleryWithAccess(friendId).then(res => {
      try {
        if (res.success && res.data && res.data.items && res.data.items.length > 0) {
          const validAlbums = res.data.items.filter((item: Album) => item.ImageCount > 0);
          res.data.items = albumModel.mappingObjects(validAlbums)?.map((i: any) => ({ ...i, friendId }));
        } else {
          console.log('ERROR: privateAlbumService/getAlbumInfos:', res.message);
        }
        return res;
      } catch (e) {
        console.log('EXCEPTION: privateAlbumService/getAlbumInfos:', e);
        throw new Error('failed');
      }
    });
  }

  getAlbumPhotos(userId: string | number, galleryId: string, imageCount?: number): Promise<IApiResponse<any>> {
    const params = { size: imageCount || 100, page: 1 };
    return privateAlbumApi.getAlbumPhotos(userId, galleryId, params).then(res => {
      try {
        if (res.success && res.data && res.data.items) {
          if (galleryId) {
            res.data.items = res.data.items.map((itm: Photo) => {
              return {
                ...itm,
                GalleryID: galleryId,
              };
            });
          }
          res.data.items = photoModel.mappingObjects(res.data.items);
        } else {
          console.log('ERROR: privateAlbumService/getAlbumPhotos:', res);
        }
        return res;
      } catch (e) {
        console.log('ERROR: privateAlbumService/getAlbumPhotos', e);
        throw new Error('failed');
      }
    });
  }

  checkGrantedAlbum(galleryId: string, userId: string): Promise<{ success: boolean; data: boolean }> {
    return privateAlbumApi.getUserGalleryWithAccess(userId).then(res => {
      try {
        if (res.success && res.data && res.data.items && res.data.items.length > 0) {
          const gallery = res.data.items.filter((item: Album) => item.GalleryID === galleryId && item.HasAccess);
          return { success: true, data: gallery && gallery.length > 0 };
        }
        console.log('ERROR: privateAlbumService/getAlbumInfos:', res.message);

        return { success: true, data: false };
      } catch (e) {
        console.log('EXCEPTION: privateAlbumService/getAlbumInfos:', e);
        throw new Error('failed');
      }
    });
  }
}

export default new PrivateAlbumService();
